import React from "react";
import CategoryPage from "./CategoryPage";

export default function ChemicalsPage() {
  return (
    <CategoryPage
      categoryMatch="chemicals"
      title="Chemicals"
      subtitle="High-quality laboratory and industrial chemicals for mining, research, and processing."
      searchPlaceholder="Search chemicals..."
    />
  );
}